import { useCallback, useEffect, useState } from "react";
import { Loader2, RefreshCw } from "lucide-react";
import AdminShell from "../components/AdminShell";
import { api } from "../lib/api";
import { DiscoveryAdminRow } from "../components/admin/DiscoveryAdminRow";
import { DiscoveryBlackouts } from "../components/admin/DiscoveryBlackouts";

const HEAD = ["Session", "Client", "Format", "Payment", "Reminder", "Status", "Actions"];

export default function AdminDiscoverySessions() {
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/admin/discovery-sessions").then((r) => setData(r.data)).catch(() => setData({ sessions: [], slots: [] })), []);
  useEffect(() => { load(); }, [load]);
  const rows = data?.sessions || [];
  const upcoming = rows.filter((r) => r.status === "confirmed" && new Date(r.start_at) > new Date()).length;

  return (
    <AdminShell current="/admin/discovery-sessions">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3" data-testid="admin-discovery-page">
        <div>
          <h1 className="text-xl font-extrabold text-white">Discovery sessions</h1>
          <p className="mt-1 text-sm text-neutral-400">
            Paid 90-minute sessions with Doreen booked via /discovery (KES 12,500). {upcoming} upcoming confirmed.
            Send virtual meeting links, move sessions, or mark them completed / cancelled / no-show.
          </p>
        </div>
        <button onClick={load} data-testid="admin-discovery-refresh"
          className="inline-flex items-center gap-1.5 rounded-lg border border-neutral-700 bg-neutral-900 px-3 py-1.5 text-xs font-semibold text-neutral-200 hover:border-[#0A8B85]">
          <RefreshCw className="h-3.5 w-3.5" /> Refresh
        </button>
      </div>
      <DiscoveryBlackouts onChanged={load} />
      {!data ? (
        <p className="inline-flex items-center gap-2 text-sm text-neutral-400"><Loader2 className="h-4 w-4 animate-spin" /> Loading bookings…</p>
      ) : rows.length === 0 ? (
        <div className="rounded-xl border border-neutral-800 bg-neutral-900/60 p-10 text-center text-sm text-neutral-400" data-testid="admin-discovery-empty">No Discovery Session bookings yet.</div>
      ) : (
        <div className="overflow-x-auto rounded-xl border border-neutral-800" data-testid="admin-discovery-table">
          <table className="w-full text-left text-xs text-neutral-300">
            <thead>
              <tr className="bg-neutral-900 text-[10px] font-bold uppercase tracking-wider text-neutral-400">
                {HEAD.map((h) => <th key={h} className="px-4 py-3">{h}</th>)}
              </tr>
            </thead>
            <tbody>{rows.map((r) => <DiscoveryAdminRow key={r.booking_id} r={r} slots={data.slots} onChanged={load} />)}</tbody>
          </table>
        </div>
      )}
    </AdminShell>
  );
}
